import React, { useEffect } from 'react';
import './locales/i18n';
import { createTheme, ThemeProvider } from '@mui/material';
import { RouterProvider } from 'react-router-dom';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { enUS as pickersEnUS, esES as pickersEsES } from '@mui/x-date-pickers/locales';
import TimeAgo from 'javascript-time-ago';
import es from 'javascript-time-ago/locale/es';
import en from 'javascript-time-ago/locale/en'; // agrega más si necesitas
import { useTranslation } from 'react-i18next';
import RouterComponent from './router';
import theme from './theme';

import dayjs from 'dayjs';
import 'dayjs/locale/es';
import 'dayjs/locale/en'; // importa todos los que necesites

function App() {
    const customTheme = createTheme(theme);
    const { i18n } = useTranslation();
    const normalizedLanguage = i18n.language?.toLowerCase().startsWith('es') ? 'es' : 'en';

    // Agregar idiomas disponibles para TimeAgo
    TimeAgo.addDefaultLocale(en);
    TimeAgo.addLocale(es);

    // Aplicar locale de dayjs según idioma activo
    useEffect(() => {
        dayjs.locale(normalizedLanguage);
    }, [normalizedLanguage]);

    return (
        <LocalizationProvider
            dateAdapter={AdapterDayjs}
            adapterLocale={normalizedLanguage}
            localeText={
                normalizedLanguage === 'es'
                    ? pickersEsES.components.MuiLocalizationProvider.defaultProps.localeText
                    : pickersEnUS.components.MuiLocalizationProvider.defaultProps.localeText
            }
        >
            <ThemeProvider theme={customTheme}>
                <RouterComponent />
            </ThemeProvider>
        </LocalizationProvider>
    );
}

export default App;
